import { Head, usePage } from "@inertiajs/react"
import { AdminShell } from "@/components/AdminShell"
import { PageHeader } from "@/components/PageHeader"
import { Breadcrumbs } from "@/components/ui/breadcrumb"
import { ConditionForm, type ConditionCategoryOption, type ConditionData } from "./ConditionForm"
import type { LibraryPhoto } from "@/components/pages-cms/types"
import type { PageProps } from "@/types/inertia"

type Props = PageProps & {
  condition: ConditionData & { id: number; path: string }
  categories: ConditionCategoryOption[]
  photo_library: LibraryPhoto[]
}

export default function ConditionsEdit() {
  const { props } = usePage<Props>()
  const { condition } = props
  // Listing and link entries have no content screen to go back to — their
  // home is the Condition menu.
  const parent = condition.kind === "page"
    ? { label: condition.label, href: `/admin/website/pages/${condition.slug}` }
    : { label: "Condition menu", href: "/admin/website/condition-categories" }

  return (
    <AdminShell>
      <Head title={`Page Settings — ${condition.label}`}>
        <meta name="description" content={`Settings for the ${condition.label} page.`} />
        <meta property="og:title" content={`Page Settings — ${condition.label}`} />
        <meta property="og:description" content={`Settings for the ${condition.label} page.`} />
      </Head>

      <Breadcrumbs
        items={[
          { label: "Website Pages", href: "/admin/website" },
          { label: "Gisela Ramirez", href: "/admin/website?brand=gisela" },
          parent,
          { label: "Settings" },
        ]}
      />

      <PageHeader
        title={`${condition.label} — settings`}
        description="The shell: address, menu group, visibility, labels and search metadata. A full page's content is edited on its own content screen."
      />
      <div className="mt-8 max-w-2xl">
        <ConditionForm
          condition={condition}
          categories={props.categories}
          actionUrl={`/admin/website/conditions/${condition.id}`}
          method="patch"
          photoLibrary={props.photo_library}
        />
      </div>
    </AdminShell>
  )
}
